import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  signal,
} from '@angular/core';
import {
  DynamicPageComponent,
  DynamicPageContentComponent,
  DynamicPageHeaderComponent,
} from '@fundamental-ngx/core/dynamic-page';
import { LuigiCoreService } from '@openmfp/portal-ui-lib';

export const DOMAIN_REDIRECT_URL_PATH = 'domain-redirect';

@Component({
  selector: 'app-domain-redirect',
  imports: [
    DynamicPageComponent,
    DynamicPageHeaderComponent,
    DynamicPageContentComponent,
  ],
  templateUrl: './domain-redirect.component.html',
  styleUrl: './domain-redirect.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DomainRedirectComponent implements OnInit {
  readonly waitingSeconds = signal(5);
  protected redirectUrl = this.getRedirectUrl(document.URL);

  constructor(private luigiCoreService: LuigiCoreService) {}

  ngOnInit(): void {
    this.luigiCoreService.ux().hideAppLoadingIndicator();
    this.waitAndRedirect();
    this.startCountdown();
  }

  waitAndRedirect(): void {
    setTimeout(() => {
      window.open(this.redirectUrl, '_self');
    }, this.waitingSeconds() * 1000);
  }

  public getRedirectUrl(url: string): string {
    const environment = this.getEnv(url);
    const mapEnvToDomain = {
      dev: '.d1.',
      int: '.i1.',
      prod: '.',
    } as const;

    const urlPathIdx =
      url.indexOf(DOMAIN_REDIRECT_URL_PATH) + DOMAIN_REDIRECT_URL_PATH.length;
    const path = url.substring(urlPathIdx + 1);
    const pathHasOnlyParams = url[urlPathIdx] === '?';

    const urlPathAndParams = !path.length
      ? ''
      : pathHasOnlyParams
        ? `?${path}`
        : `/${path}`;

    const hostname = new URL(url).hostname;
    const parts = hostname.split('.');
    const isSapTenant = parts[0] === 'sap';
    const isLocal = hostname === 'localhost';
    if (isSapTenant || isLocal) {
      return `https://portal${mapEnvToDomain[environment]}hyperspace.tools.sap${urlPathAndParams}`;
    }
    return `https://test.portal${mapEnvToDomain[environment]}hyperspace.tools.sap${urlPathAndParams}`;
  }

  private getEnv(url: string): 'prod' | 'int' | 'dev' {
    const parts = new URL(url).hostname.split('.');
    const env = parts[1];
    if (env === 'live') return 'prod';
    if (env === 'int') return 'int';
    return 'dev';
  }

  startCountdown() {
    const interval = setInterval(() => {
      if (this.waitingSeconds() > 0) {
        this.waitingSeconds.update((s) => s - 1);
      } else {
        clearInterval(interval);
      }
    }, 1000);
  }
}
